const EmailUsLink =
  "mailto:CSCgohelp@cscsw.com?subject=CSC-Go Mobile: Help Inquiry&body=If you experienced an issue with your service, a machine malfunction, or submitting a refund request, please make sure to include the 6-Digit Machine ID (Ex. ACB-000)";
export default EmailUsLink;
